import { useSuspenseQuery } from "@apollo/client";

import { MapEditorEcologicalFunctionPanelEcologicalFunctionEditableDocument } from "./queries.generated";

export function useSuspenseEcologicalFunctionEditableQuery(mapEditorFeatureId: string) {
    return useSuspenseQuery(MapEditorEcologicalFunctionPanelEcologicalFunctionEditableDocument, {
        variables: { mapEditorFeatureId },
    });
}
